import React from 'react';

//Estilos base:
let mainCardStyle = {
    paddingTop: 20
};

export const auditViewTourConfig = [
    {
        selector: '',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Esta es la consola <b>de auditoría</b>.</p>
                <p>Aquí podrás visualizar el histórico de <b>eventos importantes</b> que los usuarios
                    llevan a cabo dentro de la plataforma.</p>
                <p>Encontrarás registros desde <b>inicio de sesión</b> de usuarios, hasta <b> ejecución de descargas </b>
                    y <b>obtención de ficheros</b> generados.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__auditView.filterManagerBasedOnDate"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Con esta herramienta, puedes controlar el <b>rango de fechas</b> de los registros de auditoría que quieras ver.</p>
                <p>Cada vez que cambies una de las fechas, el sistema <b>actualizará</b> la tabla automáticamente.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__auditView.filterManagerBasedOnType"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Con esta otra, puedes controlar el <b>tipo de registro</b> que quieras ver.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__auditView.auditRecordsTable"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Esta tabla contiene el registro histórico de <b>auditoría</b>.</p>
                <p>Puedes <b>ordenar</b> la búsqueda haciendo click sobre cualquiera de los encabezados de las columnas.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__auditView.auditRecordsTableRowDescription"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Cada fila en la tabla <b>equivale</b> al <b>registro</b> de un evento importante que algún usuario ejecutó en el pasado.</p>
                <p>La información desplegada corresponde a la de dicho registro.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__auditView.auditRecordsTablePagination"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Con este conjunto de botones puedes <b>extender o reducir</b> el tamaño de tu búsqueda.</p>
            </div>
        )
    },
    {
        style: { ...mainCardStyle },
        selector: '[data-tut="reactour__auditView.auditRecordsTablePaginationResume"]',
        content: () => (
            <div style={{ ...mainCardStyle }}>
                <p>Puedes consultar la <b>cantidad</b> de registros mostrados aquí.</p>
            </div>
        )
    },

];